export function nearestCent(currency: number) {
    return Math.round(currency * 100) / 100;
}
